var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.635 0h6.25c.432 0 .782.35.782.781V5.99c0 .431-.35.78-.782.78h-6.25c-.431 0-.78-.349-.78-.78V.78c0-.431.349-.781.78-.781zM7.031 0H.781C.35 0 0 .35 0 .781V5.99c0 .431.35.78.781.78h6.25c.432 0 .782-.349.782-.78V.78C7.813.35 7.463 0 7.03 0zM0 8.594v5.208c0 .432.35.781.781.781h6.25c.432 0 .782-.35.782-.78v-5.21c0-.43-.35-.78-.782-.78H.781c-.431 0-.781.35-.781.78zm9.635 5.99h6.25c.432 0 .782-.35.782-.782V8.594c0-.432-.35-.781-.782-.781h-6.25c-.431 0-.78.35-.78.78v5.21c0 .43.349.78.78.78z",
    transform: "translate(-1292 -81) translate(1286 75) translate(6 6) translate(1.667 2.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.d74c2cd24d5e0d57c60eaf5faed678de.svg";
export { ForwardRef as ReactComponent };